export default __webpack_public_path__ + "static/media/Revenue.a3b06f5f.png";